<div class="reforestaction-page">
    <div id="page-header">
        <app-page-header (subMe)="subscribeEvent()" [isSubscribed]="isSubscribed" [total]="total" [active]="isActive" [startDate]="startDate" [endDate]="endDate"></app-page-header>
    </div>

    <div class="page-content">
        <div id="introduction-section">
            <app-introduction-section></app-introduction-section>
        </div>
        <div id="images-section">
            <app-images-section></app-images-section>
            <div class="background"></div>
        </div>
        <div id="objective-section">
            <app-objective-section></app-objective-section>
        </div>
        <div id="help-section">
            <app-help-section (subMe)="subscribeEvent()" [isSubscribed]="isSubscribed"></app-help-section>
        </div>
    </div>
</div>
